import { render, staticRenderFns } from "./user-group.vue?vue&type=template&id=1e9c6a36&scoped=true&"
import script from "./user-group.vue?vue&type=script&lang=js&"
export * from "./user-group.vue?vue&type=script&lang=js&"
import style0 from "./user-group.vue?vue&type=style&index=0&id=1e9c6a36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9c6a36",
  null
  
)

export default component.exports